// extracted by mini-css-extract-plugin
export default {"header":"UsersShared_header__3SIi4"};